<template>
  <div>
    <!-- Snackbar -->
    <v-snackbar v-model="snackbar" top :color="color" :timeout="6000" rounded elevation="2">
      <span v-if="snackbar_msg">{{ snackbar_msg }}</span>
      <v-btn dark text small @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <v-card v-if="isallowedForAccessControl" class="pa-4 rounded-xl elevation-2">
      <!-- Tabs -->
      <v-tabs v-model="tabs" background-color="brand" dark grow slider-color="yellow" class="rounded-xl">
        <v-tab>
          <v-icon left>mdi-sync</v-icon>
          Change Password
        </v-tab>
        <v-tab>
          <v-icon left>mdi-magnify</v-icon>
          Get Password
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tabs" class="mt-4">
        <!-- Change Password Tab -->
        <v-tab-item>
          <v-card flat class="pa-4">
            <v-row dense justify="center">
              <v-col cols="12" sm="5">
                <v-text-field v-model="username" outlined rounded dense label="Username" prepend-icon="mdi-account"
                  :error="!username && usernameTouched"
                  :error-messages="!username && usernameTouched ? ['Username is required'] : []"
                  @blur="usernameTouched = true"></v-text-field>
              </v-col>
            </v-row>

            <!-- Auto Generate Password -->
            <v-row dense justify="center" v-if="username">
              <v-checkbox v-model="autoGenerated" color="success" @change="handleCheckboxChange"
                label="Auto Generate Password?"></v-checkbox>
            </v-row>

            <!-- New Password -->
            <v-row dense justify="center" v-if="username">
              <v-col cols="12" sm="5">
                <v-text-field v-model="newPassword" outlined rounded dense
                  :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" :type="show1 ? 'text' : 'password'"
                  label="New Password" prepend-icon="mdi-lock" :error="!newPassword && passwordTouched"
                  :error-messages="!newPassword && passwordTouched ? ['Password is required'] : []"
                  @blur="passwordTouched = true" @click:append="show1 = !show1"></v-text-field>
              </v-col>
            </v-row>

            <!-- Action Buttons -->
            <v-row justify="center" v-if="username" class="mt-4">
              <v-btn color="primary" rounded @click="validateAndSave">
                Save
              </v-btn>
              <v-btn color="success" rounded class="ml-4" :loading="loader_for_comm" @click="validateAndCommunicate">
                <v-icon left>mdi-gmail</v-icon>
                Communicate
              </v-btn>
            </v-row>
          </v-card>
        </v-tab-item>

        <!-- Get Password Tab -->
        <v-tab-item>
          <v-card flat class="pa-4">
            <v-row dense justify="center">
              <v-col cols="12" sm="6">
                <v-combobox v-model="get_password_username" @change="setnull" rounded outlined dense :items="all_users"
                  label="Select Username" item-text="username" prepend-icon="mdi-account-search"
                  :error="!get_password_username && getUserTouched"
                  :error-messages="!get_password_username && getUserTouched ? ['Username is required'] : []"
                  @blur="getUserTouched = true"></v-combobox>
              </v-col>

              <v-col cols="12" sm="3" md="1" v-if="get_password_username">
                <v-btn color="primary" rounded block @click="validateAndGetPassword">
                  <v-icon left>mdi-eye</v-icon>
                  View
                </v-btn>
              </v-col>
            </v-row>

            <v-row justify="center" v-if="user_password && get_password_username.username" class="mt-6">
              <v-col cols="auto">
                <v-card flat outlined rounded="lg" class="pa-4" style="background-color: #f9fbfd;">
                  <v-row align="center" justify="space-between" no-gutters>
                    <v-col cols="auto" class="d-flex align-center mr-5">
                      <span class="subtitle-1 font-weight-bold">
                        <span class="mr-2">🔑</span>
                        Password for <span style="font-style: normal;">{{ get_password_username.username }}</span>
                      </span>
                      <v-chip outlined color="primary" text-color="primary" class="pa-3 ml-4 font-weight-bold text-h6">
                        {{ user_password }}
                      </v-chip>
                    </v-col>

                    <v-col cols="auto">
                      <v-btn fab small @click="copy" color="primary" :title="'Copy Password'">
                        <v-icon>mdi-content-copy</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card>

              </v-col>
            </v-row>

          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>

    <v-card v-else class="pa-5 red--text text-center rounded-xl elevation-2">
      You do not have access to this page.
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import sha256 from "js-sha256";
import "@/assets/css/color.css";

export default {
  data() {
    return {
      username: null,
      get_password_username: null,
      show1: false,
      newPassword: null,
      autoGenerated: false,
      loader_for_comm: false,
      snackbar_msg: "",
      color: "",
      snackbar: false,
      all_users: [],
      isallowedForAccessControl: false,
      tabs: 0,
      user_password: null,
      // Validation tracking
      usernameTouched: false,
      passwordTouched: false,
      getUserTouched: false,
    };
  },

  methods: {
    handleCheckboxChange() {
      if (this.autoGenerated) this.getcreateRandomPassword();
    },

    getcreateRandomPassword() {
      axios
        .post("/RoleManagement/createRandomPassword", { flag: this.autoGenerated })
        .then((res) => {
          if (res.data.flag === "YES") {
            this.newPassword = res.data.generatednewpassword;
            this.showSnackbar("#4caf50", "Created Random Password successfully!");
          } else {
            this.showSnackbar("#b71c1c", res.data.snackbar);
          }
        })
        .catch(() => this.showSnackbar("#b71c1c", "Something went wrong!!!"));
    },

    validateAndSave() {
      this.usernameTouched = true;
      this.passwordTouched = true;
      if (!this.username || !this.newPassword) return;
      this.saveData();
    },

    validateAndCommunicate() {
      this.usernameTouched = true;
      if (!this.username) return;
      this.communicatePassword();
    },

    validateAndGetPassword() {
      this.getPassword();
    },

    saveData() {
      if (confirm("Are you sure you want to change the password?")) {
        axios
          .post("/RoleManagement/changeAdminPassword", {
            username: this.username,
            password: this.newPassword,
          })
          .then((res) => {
            if (res.data.flag === "YES") {
              this.newPassword = "";
              this.showSnackbar("#4caf50", res.data.snackbar);
            } else {
              this.showSnackbar("#b71c1c", res.data.snackbar);
            }
          })
          .catch(() => this.showSnackbar("#b71c1c", "Something went wrong!!!"));
      }
    },

    communicatePassword() {
      this.loader_for_comm = true;
      axios
        .post("/RoleManagement/communicatePassword", { username: this.username })
        .then((res) => {
          this.loader_for_comm = false;
          if (res.data.flag === "YES") {
            this.showSnackbar("#4caf50", res.data.snackbar);
          } else {
            this.showSnackbar("#b71c1c", res.data.snackbar);
          }
        })
        .catch(() => {
          this.loader_for_comm = false;
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
        });
    },

    getPassword() {
      let checksum = sha256(this.get_password_username.username + process.env.VUE_APP_SHA_KEY);
      axios
        .post("/Admin/getUsernamePassword", {
          checksum,
          username: this.get_password_username.username,
        })
        .then((res) => {
          if (res.data.flag === "YES") {
            this.user_password = res.data.user_password;
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
        })
        .catch(this.onerror);
    },

    setnull() {
      this.user_password = null;
    },

    copy() {
      navigator.clipboard.writeText(this.user_password);
      this.showSnackbar("#4caf50", "Password copied to clipboard!");
    },

    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },

    onerror() {
      this.showSnackbar("error", "Something went wrong.");
    },
  },

  mounted() {
    axios
      .post("/Admin/getAllUserAndCheckAccessControl")
      .then((res) => {
        if (res.data.flag === "No") {
          this.showSnackbar("red", res.data.snackbar);
        } else {
          this.all_users = res.data.all_users;
          this.isallowedForAccessControl = res.data.isallowed;
        }
      })
      .catch(() => console.error("Error fetching users"));
  },
};
</script>

<style scoped>
.v-tabs {
  border-radius: 12px;
}

.v-tab {
  font-weight: bold;
  letter-spacing: 0.5px;
}

.v-card {
  background: #fff;
}

.v-chip {
  font-size: 16px;
}

.main-card {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.custom-tabs {
  background: linear-gradient(to right, #b2d8f7, #f4d1f4);
  border-radius: 30px;
  padding: 2px;
  min-height: 50px;
}

.custom-tab {
  font-weight: normal;
  color: black;
  text-transform: uppercase;
  font-size: 14px;
  min-height: 40px;
  border-radius: 0;
}

.first-tab {
  border-top-left-radius: 30px;
  border-bottom-left-radius: 30px;
}

.active-tab {
  background: white !important;
  color: black !important;
  font-weight: bold !important;
}
</style>
